import React, { useEffect } from 'react';
import {useUserManager} from './UserManagerContext'; // Import your OIDC userManager instance
import { createUserManager } from './userManager';


const Logout = () => {
  const { userManager, setUserManager } = useUserManager()
  const routeRobot = window.location.pathname.split('/')[1]
  let activeUserManager = userManager
  try {
    let user = null
    
    if (userManager === null){
      console.log("User Manager not set")
      activeUserManager = createUserManager(routeRobot)
      setUserManager( activeUserManager)
      user = activeUserManager.getUser();
    }else{
      activeUserManager = userManager;
    }
  } catch (error) {
    console.error("Error during Logout", error);
  }
  useEffect(() => {
    // Sign out the user and redirect to the specified post-logout URL
    activeUserManager.signoutRedirect().catch(err => {
      console.error('Error during logout:', err);
    });
  }, []);

  return <div>Logging out...</div>;
};

export default Logout;
